(() => {
  function hasCallgearScript() {
    if (window.__isComagicScriptLoaded) return true;
    if (document.querySelector('script[data-callgear-loader="1"]')) return true;
    return Array.from(document.scripts).some(function (script) {
      var src = script.src || '';
      return src.indexOf('callgear') !== -1 && src.indexOf('cs.min.js') !== -1;
    });
  }

  function loadCallgear() {
    if (hasCallgearScript()) return;
    const script = document.createElement('script');
    script.async = true;
    script.dataset.callgearLoader = '1';
    script.src =
      'https://app.callgear.ae/static/cs.min.js?k=720G0F5ycvu1Z2OLcBYsBL2P8_RLtIKO';
    document.head.appendChild(script);
  }

  function getPhone(el) {
    return (el.getAttribute('data-comagic-whatsapp') || '').trim();
  }

  function notifyCallgear(phone) {
    if (!window.Comagic?.omni?.forwardWhatsApp) return false;
    try {
      if (phone) Comagic.omni.forwardWhatsApp(phone);
      else Comagic.omni.forwardWhatsApp();
      return true;
    } catch (_err) {
      return false;
    }
  }

  function notifyCallgearWithRetries(phone, attemptsLeft) {
    if (notifyCallgear(phone)) return;
    if (attemptsLeft <= 0) return;
    window.setTimeout(function () {
      notifyCallgearWithRetries(phone, attemptsLeft - 1);
    }, 120);
  }

  function openWhatsApp(phone) {
    if (!phone) return;
    window.open(
      'https://api.whatsapp.com/send?phone=' + phone,
      '_blank',
      'noopener,noreferrer'
    );
  }

  function handleClick(event, el) {
    const control = el || (event && event.currentTarget);
    if (!control) return true;

    loadCallgear();
    const phone = getPhone(control);
    const isLink =
      control.tagName === 'A' &&
      control.href &&
      control.href !== '#' &&
      !control.hasAttribute('aria-disabled');

    notifyCallgearWithRetries(phone, 8);

    if (isLink) {
      return true;
    }

    if (event && event.preventDefault) event.preventDefault();
    openWhatsApp(phone);
    return false;
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest('[data-comagic-whatsapp]')) return;
      loadCallgear();
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var control = target.closest('[data-comagic-whatsapp]');
      if (!control) return;
      if (handleClick(event, control) === false && event.preventDefault) {
        event.preventDefault();
      }
    },
    true
  );

  window.AmprioCallGear = { handleClick, load: loadCallgear };
})();
